import {
    Card,
    CardContent,
    CardHeader,
    Divider,
    Typography,
    Button,
    Box,
} from "@mui/material";
import { Check, FileCopyOutlined } from "@mui/icons-material";
import copy from 'copy-to-clipboard';
import { useTranslation } from "react-i18next";
import { useState } from "react";

export default function CopyLinkCard({
    title,
    link,
}) {
    const { t } = useTranslation()
    const [isCopied, setIsCopied] = useState(false)
    const handleClick = _ => {
        copy(link)
        setIsCopied(true)
        setTimeout(() => {
            setIsCopied(false)
        }, 3000);
    }

    return (
        <Card sx={{ height: "100%", display: 'flex', flexDirection: 'column' }}>
            <CardHeader title={title} action={
                <Button
                    m={1}
                    variant="contained"
                    color="white"
                    startIcon={isCopied ? <Check color="success" /> : <FileCopyOutlined />}
                    size="small"
                    onClick={handleClick}
                    sx={{ textTransform: "none" }}
                >
                    {t("Copy")}
                </Button>
            } />
            <Divider />
            <CardContent sx={{ flex: 1 }}  >
                <bdi>
                    <Box backgroundColor="#F4F6F8" p={1} borderRadius={2} textAlign="center">
                        <Typography variant="subtitle2" sx={{ wordBreak: 'break-word' }}>
                            {link}
                        </Typography>
                    </Box>
                </bdi>
            </CardContent>
            <Divider />
        </Card>
    );
};
